<template>
  <div>
    <p class="my-4">
      Preview
    </p>
    <div class="bg-gray-100 flex px-4 py-4 rounded-md">
      <div class="shadow-2xl bg-white text-sm rounded-md px-2 py-2 relative">
        <div
          class="bg-white absolute w-4 h-4 right-0 top rounded-full cursor-pointer"
          style="top: -6px;right: -6px;"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="stroke-current text-gray-400 "
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </div>
        <span class="text-gray-700">{{ config.welcomeMessage.text }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CalloutCardPreview",
  props: {
    config: {
      type: Object,
      default() {
        return {};
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
